import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";


import {
    createCommentLike,
    createSubCommentLike,
    deleteCommentLike,
    deleteSubCommentLike
} from "../../../creators/comment.like";
import {fetchLikes} from "../../../creators/likes";

import {Can} from "../../../ability-context";
import Modal from "../Modal";
import history from "../../../libs/history";

import EncourageSignup from "../../components2/encourageSignup/EncourageSignup";

class LikeComment extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            toggleLike: this.props.isLiked || false,
            classActive: false,
            value: this.props.value || 0,
            toggleSignIn: false,
            togglePopup: false,
            toggleModalEmailUnconfirmed : false
        };
        this.modal = this.props.clickCta["like"];
        this.handleToggleLike = this.handleToggleLike.bind(this);
    };

    handleToggleLike(e) {
        e.stopPropagation();
        if(this.props.currentUserId){
            let value = this.state.value;
            if (!this.state.toggleLike) {
                if(this.props.isComment){
                    this.props.createCommentLike(this.props.likeType, this.props.parentId, this.props.commentId);
                } else {
                    this.props.createSubCommentLike(this.props.likeType, this.props.parentId, this.props.commentId, this.props.subCommentId);
                }
                value++;
            } else {
                if(this.props.isComment){
                    this.props.deleteCommentLike(this.props.likeType, this.props.parentId, this.props.commentId);
                } else {
                    this.props.deleteSubCommentLike(this.props.likeType, this.props.parentId, this.props.commentId, this.props.subCommentId);
                }
                value--;
            }
            this.setState({toggleLike: !this.state.toggleLike, classActive: !this.state.classActive, value});
        }
        // else {
        //     this.setState({toggleSignIn: !this.state.toggleSignIn});
        // }
    }

    render(){

        return(
            <Fragment>
                <Can action="create" subject="Like" passThrough>
                    {can => {
                        return can ? (
                            <div className={`likes ${this.state.toggleLike && 'active'}`}
                                 onClick={(e) => this.handleToggleLike(e)}>
                                J'aime{this.state.value > 1 ? 's' : ""} ({this.state.value || 0})
                            </div>
                        ) : (
                            <Fragment>
                                {this.props.currentUserInitialized ? (
                                    this.modal && this.modal.modal ? (
                                        <Fragment>
                                            <div className={`likes ${this.state.toggleLike && 'active'}`}
                                                 onClick={(e) => this.setState({togglePopup: true})}>
                                                J'aime{this.state.value > 1 ? 's' : ""} ({this.state.value || 0})
                                            </div>
                                            <Modal toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})}>
                                                <this.modal.modal username={this.props.currentUser.username} userId={this.props.currentUser._id} handleClose={() => this.setState({togglePopup: false})} />
                                            </Modal>
                                        </Fragment>
                                    ) : (
                                        <div className={`likes ${this.state.toggleLike && 'active'}`}
                                             onClick={() => this.modal.to ? history.push(this.modal.to) : null}>
                                            J'aime{this.state.value > 1 ? 's' : ""} ({this.state.value || 0})
                                        </div>
                                    )
                                ) : (
                                    <Fragment>
                                        <div className={`likes ${this.state.toggleLike && 'active'}`}
                                             onClick={() => this.setState({togglePopup: true})} >
                                            J'aime{this.state.value > 1 ? 's' : ""} ({this.state.value || 0})
                                        </div>
                                        <EncourageSignup toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})} />
                                    </Fragment>
                                )}
                            </Fragment>
                        )}}
                </Can>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
        clickCta : state.clickCta.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLikes,

    createCommentLike,
    deleteCommentLike,

    createSubCommentLike,
    deleteSubCommentLike,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LikeComment);